import React, { useState } from "react";
import { post } from "../../lib/Fetching";
import TodoInput from "./TodoInput";

export default function TodoPicker({ ids, onApply, clientView }) {
  const [todoText, setTodoText] = useState("");
  const [topicId, setTopicId] = useState(null);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!todoText.trim()) {
      alert("Please enter a todo");
      return;
    }

    if (!topicId) {
      alert("Please select a topic");
      return;
    }

    post("/registration/todos/create_bulk", {
      ids: ids,
      body: todoText,
      topic_id: topicId,
    })
      .then(() => {
        onApply();
        setTodoText("");
        setTopicId(null);
      })
      .catch((e) => {
        console.error("Error creating bulk todos:", e);
        const message = e && e.message ? e.message : "Failed to create todos. Please try again.";
        alert(message);
      });
  };

  const sampleCount = ids && ids.length ? ids.length : 0;
  const sampleIdsText = ids && ids.length ? ids.join(", ") : "None";

  return (
    <div>
      <div style={{ marginBottom: 15 }}>
        <p>
          <strong>{sampleCount} sample(s) selected:</strong> {sampleIdsText}
        </p>
      </div>
      <form onSubmit={handleSubmit} className="form-inline">
        <TodoInput
          todoText={todoText}
          setTodoText={setTodoText}
          topicId={topicId}
          setTopicId={setTopicId}
          clientView={clientView}
        />
      </form>
    </div>
  );
}
